export const BuildInfo = {timestamp:1792693726000}
